
document.addEventListener('DOMContentLoaded', function(){
  if (!location.pathname.includes('/products/')) return;

  const original = document.getElementById('AddToCart');
  if (!original) return;

  // Sentinela estable
  const placeholder = document.createElement('span');
  original.parentNode.insertBefore(placeholder, original.nextSibling);

  // Footer flotante con mismo wrapper que el original
  const sticky = document.createElement('div');
  sticky.className = 'sticky-footer add_to_cart_holder';
  const proxy = document.createElement('button');
  proxy.type = 'button';
  proxy.className = 'button'; // clase de estilo clave
  sticky.appendChild(proxy);
  document.body.appendChild(sticky);

  // Click del proxy = click del original
  proxy.addEventListener('click', function(e){
    e.preventDefault();
    if (proxy.disabled) return;
    original.click();
  });

  // Sincroniza contenido y estado
  const mirror = () => {
    proxy.innerHTML = original.innerHTML;
    proxy.disabled = original.disabled;
  };
  mirror();

  const mo = new MutationObserver(mirror);
  mo.observe(original, { attributes:true, childList:true, subtree:true, attributeFilter: ['disabled'] });

  // Mostrar/ocultar según visibilidad + scroll con histéresis
  const ENTER_SCROLL = 0;
  const EXIT_SCROLL  = 320;

  const evaluate = (origVisible) => {
    const y = window.scrollY || window.pageYOffset;
    if (!origVisible && y >= ENTER_SCROLL){
      sticky.style.display = 'block';
    } else if (origVisible || y <= EXIT_SCROLL){
      sticky.style.display = 'none';
    }
  };

  const io = new IntersectionObserver((entries)=>{
    evaluate(entries[0].isIntersecting);
  }, {threshold: 0});
  io.observe(placeholder);

  const fallback = () => {
    const r = placeholder.getBoundingClientRect();
    const visible = r.bottom > 0 && r.top < window.innerHeight;
    evaluate(visible);
  };
  window.addEventListener('scroll', ()=>requestAnimationFrame(fallback), {passive:true});
  window.addEventListener('resize', ()=>requestAnimationFrame(fallback));
  fallback();
});




//Add2 - Add3
/*
const submit = document.getElementById('AddToCart');
const input = document.querySelector('.add_to_cart_holder .qty');
const plus2 = document.querySelector('.plus-button.plus2');
const plus3 = document.querySelector('.plus-button.plus3');
plus2.addEventListener('click', (e) => {
    input.value = 2;
    submit.click();
});
plus3.addEventListener('click', (e) => {
    input.value = 3;
    submit.click();
});
var inputs = document.querySelectorAll('.add_to_cart_holder .qty');
inputs.forEach(function (element) {
    element.addEventListener("change", function () {
        let quantity = element.value;
        if (quantity == 1) {
            plus2.classList.remove("active");
            plus3.classList.remove("active");
        }
        if (quantity == 2) {
            plus2.classList.add("active");
            plus3.classList.remove("active");
        }
        if (quantity == 3) {
            plus2.classList.remove("active");
            plus3.classList.add("active");
        }
    });
});*/
//END Add2 - Add3

//change position of appstle one-time purchase
/*
function runAfterElementExists(id_selector,callback){
    var checker = window.setInterval(function() {
     //if one or more elements have been yielded by jquery
     //using this selector
     if (document.getElementById(id_selector)) {
        console.log("comprueba");
        //stop checking for the existence of this element
        clearInterval(checker);

        //call the passed in function via the parameter above
        callback();
        }}, 200); //I usually check 5 times per second
}
runAfterElementExists("appstle_selling_plan_label_10", function(){
   let OneTime = document.getElementById("appstle_selling_plan_label_10").parentElement;
    document.getElementById("appstle_selling_plan_label_10").parentElement.remove();
    document.querySelector(".appstle_widget_title").prepend(OneTime);
});
*/
/*if (
  window.PRODUCT_ID == 8448829849943 || // Culinary Matcha Tea Powder
  window.PRODUCT_ID == 8448830439767 || // Premium Matcha Tea
  window.PRODUCT_ID == 8448840761687 || // Jasmine Matcha Tea
  window.PRODUCT_ID == 8448841449815 || // Reserve Matcha Tea
  window.PRODUCT_ID == 8455446004055 || // English Breakfast Matcha Tea
  window.PRODUCT_ID == 8480475545943 || // Original Matcha Tea
  window.PRODUCT_ID == 8540451406167 || // Earl Grey Matcha Tea
  window.PRODUCT_ID == 8540584444247 || // Rooibos Matcha Tea
  window.PRODUCT_ID == 8540759916887 || // Spicy Chai Tea
  window.PRODUCT_ID == 8543048958295 || // Skin Cure
  window.PRODUCT_ID == 8543534088535 || // Inner Cure
  window.PRODUCT_ID == 8544194789719 || // Hair & Nails
  window.PRODUCT_ID == 8545365033303 || // Facial Glow Serum
  window.PRODUCT_ID == 8545372733783 || // Matcha Collagen
  window.PRODUCT_ID == 8551030751575 || // Organic Erythritol
  window.PRODUCT_ID == 8652697436503 || // Matcha Marine Collagen
  window.PRODUCT_ID == 9456785031511 || // Matcha Creatine
  window.PRODUCT_ID == 9522457117015 || // Matcha Chocolate
  window.PRODUCT_ID == 9801472573783 || // Matcha Vanilla
  window.PRODUCT_ID == 9931644928343 || // PH-MAC product T (test)
  window.PRODUCT_ID == 10145082179927 || // Matcha Golden Milk
  window.PRODUCT_ID == 10157445939543    // Matcha Latte
) { 
  document.addEventListener( 
    'AppstleSubscription:SubscriptionWidget:widgetInitialised', 
    (e) => { 
      const HIDDEN_SUBSCRIPTIONS = ["691455328599", "691455295831"]; 
      const hideSubscriptions = () => { 
        HIDDEN_SUBSCRIPTIONS.forEach((id) => { 
          const oldSubscriptions = document.querySelectorAll(`.appstle-radio-wrapper:has(#appstle_subscription_widget0-${id})`);
          oldSubscriptions.forEach((wrapper) => { 
            wrapper.style.display = "none"; 
          }); 
        }); 
        console.log('Ocultados los planes de suscripción');
      }; 
      // Espera 1 segundo después de que Appstle se inicialice 
      setTimeout(hideSubscriptions, 1000); 

      // --- Reaplicar al cambiar de variante (sin spam de logs) ---
      const variantInput = document.querySelector('form[action*="/cart/add"] [name="id"]') || document.querySelector('[name="id"]');
      let lastVariantId = variantInput ? (variantInput.value || variantInput.getAttribute('value')) : null;

      const rehideAfterVariantChange = () => {
        // Appstle suele re-renderizar con un pequeño retraso tras el cambio de variante
        setTimeout(hideSubscriptions, 300);
        setTimeout(hideSubscriptions, 1200);
      };

      const onVariantMaybeChanged = () => {
        if (!variantInput) return;
        const currentVariantId = variantInput.value || variantInput.getAttribute('value');
        if (currentVariantId !== lastVariantId) {
          lastVariantId = currentVariantId;
          rehideAfterVariantChange();
        }
      };

      if (variantInput) {
        variantInput.addEventListener('change', onVariantMaybeChanged);
      }

      document.addEventListener('variant:change', onVariantMaybeChanged);
      document.addEventListener('variant:changed', onVariantMaybeChanged);
    } 
  ); 
}*/
